export default "__VITE_ASSET__CI8KJSKL__";